import SavedCartPage from './SavedCartPage';

export default SavedCartPage;
